enum AccountStatus {
  SOFT = 'SOFT',
  UAKU = 'UAKU',
  UAOS = 'UAOS',
  AVKU = 'AVKU',
  AVOS = 'AVOS',
  ZGOA = 'ZGOA',
  ZAIB = 'ZAIB',
  ZAIA = 'ZAIA',
  ZAIT = 'ZAIT',
  ZAOT = 'ZAOT',
  ZDBE = 'ZDBE',
  ZM4 = 'ZM4',
  ZM3 = 'ZM3',
  ZINO = 'ZINO',
  DOD = 'DOD',
  ZINL = 'ZINL',
  ZP2E = 'ZP2E',
}

export default AccountStatus;
